import { SearchState, SearchAction } from '@/types/state';

export const initialSearchState: SearchState = {
  query: '',
  results: [],
  loading: false,
  hasSearched: false,
};

export function searchReducer(state: SearchState, action: SearchAction): SearchState {
  switch (action.type) {
    case 'SET_QUERY':
      return { ...state, query: action.payload };
      
    case 'SET_RESULTS':
      return {
        ...state,
        results: action.payload,
        hasSearched: true,
      };
      
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
      
    case 'SET_HAS_SEARCHED':
      return { ...state, hasSearched: action.payload };
      
    case 'CLEAR_RESULTS':
      return {
        ...state,
        results: [],
        hasSearched: false,
      };
      
    case 'RESET_SEARCH':
      return initialSearchState;
      
    default:
      return state;
  }
}
